import OrderStore from './OrderStore';

export * from './OrderStore.dto';
export default new OrderStore();
